import React from 'react';
import ValidatedInput from '../../../../../../common/components/ValidatedInput';

const NumberInput = props => (
  <ValidatedInput
    {...props}
    validation={[
      {
        pattern: /^-?\d{0,6}$/g,
        message: 'Please enter a valid number.',
        restrictInput: true,
        events: ['onChange'],
      },
      {
        checkValid: value => value.trim === '' || !isNaN(value),
        message: 'Please enter a valid number',
        events: ['onBlur'],
      },
    ]}
  />
);

export default NumberInput;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/InputTypes/NumberInput.js